import React, { useEffect, useState } from 'react';
// import { useHistory } from 'react-router-dom'
import {
    Nav,
    NavItem,
    Navbar,
    NavbarBrand,
    Collapse,
    DropdownItem,
    Badge,
    Button,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu
} from 'reactstrap';
import { getCurrentUser } from '../../services/user-service';
import profilephoto from '../../assets/images/users/1.jpg';

// Icon
import { RiAccountCircleLine } from "react-icons/ri";

/*--------------------------------------------------------------------------------*/
/* Import images which are need for the HEADER                                    */
/*--------------------------------------------------------------------------------*/
import crmlogo from '../../assets/images/marketcrm.png';
import apifdfLogo from '../../assets/images/APIFDF.png';
import mcrmlogo from '../../assets/images/market-crm.png';

const Header = (props) => {

    const [email, setEmail] = useState('');
    const [name, setName] = useState('');

    var doLogout = (e) => {
        localStorage.removeItem('userToken');
    }

    var myProfile = () => {
        props.history.push('/my-profile');
     }

    useEffect(() => {
        getCurrentUser().then((result) => {
            if (result != null) {
                setEmail(result.email);
                setName(result.name);
            }
        })
    });

    /*--------------------------------------------------------------------------------*/
    /*To open SIDEBAR-MENU in MOBILE VIEW                                             */
    /*--------------------------------------------------------------------------------*/
    const showMobilemenu = () => {
        document.getElementById('main-wrapper').classList.toggle('show-sidebar');
    }

    return (
        <header className="topbar navbarbg" data-navbarbg="skin1">
            <Navbar className="top-navbar" dark expand="md">
                <div className="navbar-header" id="logobg" data-logobg="skin6">
                    {/*--------------------------------------------------------------------------------*/}
                    {/* Logos Or Icon will be goes here for Light Layout && Dark Layout                */}
                    {/*--------------------------------------------------------------------------------*/}
                    <NavbarBrand>
                        <b className="logo-icon">
                            <img src={apifdfLogo} alt="homepage" style={{ height: "50px"}} />
                        </b>
                        <span className="logo-text">
                            {/* <img
                                src={mcrmlogo}
                                alt="homepage"
                            /> */}
                            Sales tracker
                        </span>
                    </NavbarBrand>
                    {/*--------------------------------------------------------------------------------*/}
                    {/* Mobile View Toggler  [visible only after 768px screen]                         */}
                    {/*--------------------------------------------------------------------------------*/}
                    <button className="btn-link nav-toggler d-block d-md-none" onClick={() => showMobilemenu()}>
                        <i className="ti-menu ti-close" />
                    </button>
                </div>

                <Collapse className="navbarbg" navbar data-navbarbg="skin1" >
                    {/* <div style={{ marginLeft: '200px' }}>
                        <h5><Badge color="primary" pill>
                            Primary
                  </Badge>
                            <Badge color="secondary" className="ml-3" pill>
                                Secondary
                  </Badge>
                            <Badge color="success" className="ml-3" pill>
                                Success
                  </Badge>
                            <Badge color="danger" className="ml-3" pill>
                                Danger
                  </Badge>
                            <Badge color="warning" className="ml-3" pill>
                                Warning
                  </Badge>
                            <Badge color="info" className="ml-3" pill>
                                Info
                  </Badge>
                            <Badge color="light" className="ml-3" pill>
                                Light
                  </Badge>
                            <Badge color="dark" className="ml-3" pill>
                                Dark
                  </Badge></h5>
                    </div> */}
                    <Nav className="ml-auto float-right" navbar>

                        {/* <NavItem>
                            <a href="link" className="btn btn-danger mr-2" style={{ marginTop: '15px' }}>Upgrade to Pro</a>
                        </NavItem> */}
                        <NavItem>
                            {/* <h6 href="link" style={{ marginTop: '25px', color: 'white' }}>{name}</h6> */}
                            <h6 href="link" style={{ marginTop: '25px', color: 'white', lineHeight: '0' }}>{name}</h6>
                            <span style={{ color: 'white' }}>{email}</span>
                        </NavItem>
                        {/*--------------------------------------------------------------------------------*/}
                        {/* Start Profile Dropdown                                                         */}
                        {/*--------------------------------------------------------------------------------*/}
                        <UncontrolledDropdown nav inNavbar>
                            <DropdownToggle nav caret className="pro-pic">
                                <RiAccountCircleLine size={28} />
                            </DropdownToggle>
                            <DropdownMenu right className="user-dd">
                                <DropdownItem href="/my-profile">
                                    <i style={{color:'green'}} className="ti-user mr-1 ml-1" /> My Profile
                  </DropdownItem>
                                {/* <DropdownItem>
                                    <i className="ti-wallet mr-1 ml-1" /> My Balance
                  </DropdownItem> */}
                                {/* <DropdownItem>
                                    <i className="ti-email mr-1 ml-1" /> Inbox
                  </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem>
                                    <i className="ti-settings mr-1 ml-1" /> Account Settings
                  </DropdownItem> */}
                                {/* <DropdownItem divider /> */}
                                <DropdownItem href="#/login" onClick={() => doLogout()}>
                                    <i style={{color:'red'}} className="fa fa-power-off mr-1 ml-1" /> Logout
                  </DropdownItem>
                                {/* <DropdownItem divider /> */}
                                {/* <Button color="success" className="btn-rounded ml-3 mb-2 mt-2">
                                    View Profile
                                </Button> */}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        {/*--------------------------------------------------------------------------------*/}
                        {/* End Profile Dropdown                                                           */}
                        {/*--------------------------------------------------------------------------------*/}
                    </Nav>
                </Collapse>
            </Navbar>
        </header>
    );
}
export default Header;